/* eg-card-image-fit.js
   Detects image aspect ratio for product cards. If the image is significantly
   wider or taller than its 1:1 container, swap to `object-fit: contain` with
   a black background so the whole image is visible (no zoom). Square-ish
   images (0.77–1.3 aspect ratio) keep the default `cover` behavior. */
(function(){
  var THRESHOLD_HI = 1.30; // wider than 1:1.3 = landscape → contain
  var THRESHOLD_LO = 0.77; // taller than 1:0.77 = portrait → contain
  var SELECTORS = [
    '.card__media img',
    '.eg-product-card-image img',
    '.egpc-imgbox img',
    '.egpc-thumb img'
  ].join(',');

  function fit(img){
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    var ar = img.naturalWidth / img.naturalHeight;
    if (ar > THRESHOLD_HI || ar < THRESHOLD_LO) {
      // Find the closest image wrapper (.media, .eg-product-card-image, .egpc-imgbox, or parent)
      var wrap = img.closest('.media, .eg-product-card-image, .egpc-imgbox, .egpc-thumb');
      if (!wrap) wrap = img.parentElement;
      if (wrap && !wrap.classList.contains('media--contain')) {
        wrap.classList.add('media--contain');
      }
    }
  }

  function scan(){
    var imgs = document.querySelectorAll(SELECTORS);
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.complete && img.naturalWidth > 0) {
        fit(img);
      } else {
        img.addEventListener('load', (function(el){ return function(){ fit(el); }; })(img), { once: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Re-scan after dynamic content (lazy-load, ajax filters, etc.)
  setTimeout(scan, 600);
  setTimeout(scan, 2000);

  // Also watch for DOM mutations in case of infinite scroll / filtered collections
  if (window.MutationObserver) {
    var debounced;
    var observer = new MutationObserver(function(){
      clearTimeout(debounced);
      debounced = setTimeout(scan, 200);
    });
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
})();
